.biel-message__sources {
  margin-top: 10px;
}

.biel-message__sources-toggle {
  display: flex;
  align-items: center;
  background-color: var(--biel-message-source-bg-color);
  border: none;
  padding: 5px 10px;
  cursor: pointer;
  font-size: var(--biel-message-source-font-size);
  border-radius: 4px;
  margin-bottom: 5px;
  color: var(--biel-message-source-text-color);
}

.biel-message__sources-toggle:hover {
  background-color: var(--biel-message-source-bg-hover-color);
}

.biel-message__sources-toggle span {
  margin-right: 5px;
}

.biel-message__sources-list {
  padding-left: 0;
  list-style: none;
  margin: 0;
}

.biel-message__source-item {
  margin: 5px 0;
  display: flex;
  align-items: flex-start;
}

.biel-message__source-item svg {
  flex-shrink: 0; 
  position: relative;
  top: 0.2em;
  margin-right: 5px;
}

.biel-message__source-item a {
  color: var(--biel-message-link-color);
  text-decoration: none;
}

.biel-message__source-item a:hover {
  text-decoration: underline;
}